import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import { selectLoggedIn } from 'selectors/accountSelectors'

/**
 * Whether a logged-in customer's Société account hasn't been read yet, so it isn't known whether
 * they're a member or their account is closed. The server render ignores a failed read, so a closed
 * account only shows as closed once the browser's read fails.
 */
const getIsLoyaltyAccountLoading = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => selectLoggedIn(state),
  (state: App.State) => state.loyalty.account,
  (loyaltyEnabled, isLoggedIn, loyaltyAccount): boolean => {
    if (!loyaltyEnabled || !isLoggedIn) return false
    return !!(loyaltyAccount.initial || loyaltyAccount.fetching)
  },
)

export default getIsLoyaltyAccountLoading
